import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetComplianceRecordStatusesAsync,
  GetComplianceRecordTypesAsync,
  IComplianceRecordTypesList,
  IComplianceStatusesList,
} from "../../api/ICompliance";
import { RootState } from "../store";

export interface ComplianceState {
  fetchStatus: string;
  complianceRecordTypes?: IComplianceRecordTypesList;
  complianceStatuses?: IComplianceStatusesList;
}

const initialState: ComplianceState = {
  fetchStatus: "Loading...",
  complianceRecordTypes: undefined,
  complianceStatuses: undefined,
};

export const loadComplianceOptionsAsync = createAsyncThunk(
  "compliance/loadOptions",
  async (profileId: string) => {
    const recordTypes = await GetComplianceRecordTypesAsync(profileId);
    const recordStatuses = await GetComplianceRecordStatusesAsync();
    // The value we return becomes the `fulfilled` action payload
    return {
      recordTypes: recordTypes,
      recordStatuses: recordStatuses,
    };
  }
);

export const complianceOptionsSlice = createSlice({
  name: "complianceOptions",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadComplianceOptionsAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadComplianceOptionsAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.complianceRecordTypes = action.payload.recordTypes;
        state.complianceStatuses = action.payload.recordStatuses;
      });
  },
});

export const selectComplianceOptions = (state: RootState) =>
  state.complianceOptions;

export default complianceOptionsSlice.reducer;
